import React from 'react';
import config from '../constants';

export const NotAutorized = ({ message = '' }) => {
	return (
		<div className="not-authorized d-flex align-items-center justify-content-center text-muted f-20 pos-relative f-w-100 sub text-center align-middle">
			{message.length !== 0 ? message : config.app.error}
		</div>
	);
};
